import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 28, className = '' }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-70px' }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ index, overline, title, description, dark = false }) => (
  <div className="max-w-2xl">
    <Reveal>
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-coral" data-testid="section-overline">
        {index ? `${index} / ${overline}` : overline}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`mt-4 font-display text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl ${dark ? 'text-white' : 'text-navy'}`}>
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base md:text-lg ${dark ? 'text-white/70' : 'text-slate-600'}`}>{description}</p>
      </Reveal>
    )}
  </div>
);

export const PageHero = ({ overline, title, description, children }) => (
  <section className="relative overflow-hidden bg-navy pb-20 pt-36 md:pb-28 md:pt-44">
    <div className="bg-grid-dark absolute inset-0" />
    <div className="absolute -right-32 -top-32 h-96 w-96 rounded-full bg-coral/15 blur-3xl" />
    <div className="relative mx-auto max-w-7xl px-6 md:px-12">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-xs font-bold uppercase tracking-[0.25em] text-coral"
        data-testid="page-overline"
      >
        {overline}
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="mt-5 max-w-3xl font-display text-4xl font-extrabold tracking-tighter text-white sm:text-5xl lg:text-6xl"
      >
        {title}
      </motion.h1>
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-6 max-w-2xl text-base text-white/70 md:text-lg"
        >
          {description}
        </motion.p>
      )}
      {children}
    </div>
  </section>
);
